import { IApiRequestConfig } from '../api.types';

export interface ISupportRequestPayload {
  topic: string;
  description: string;
  image?: string;
  page_url?: string;
  browser?: string;
  os?: string;
  language?: string;
  timezone?: string;
}

export const submitSupportRequestApi = (
  payload: ISupportRequestPayload,
): IApiRequestConfig<ISupportRequestPayload> => ({
  apiRouteKey: 'submitSupportRequest',
  uri: 'json',
  action: 'self/support',
  method: 'post',
  data: payload,
  v2: true,
});
